import "./App.css";
import 'react-loading-skeleton/dist/skeleton.css'
import { useState,useEffect } from "react";
import { getInitData, getSecondaryData } from "./api/initialApis";
import StudentRoute from "./routes/StudentRoute";
import { setTitle } from "./utils/helpers";
import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "./reducers/userSlice";
import SomethingWentWrong from "./components/something_went_wrong";
import useLangInit from './hooks/useLangInit';
import { getCache } from "./components/Page/utils/cacheManager";
import { commonModuleName } from "./constants/config";
import { setCart } from "./reducers/cartSlice";
import { setConfigData } from "./reducers/configSlice";
import { setAdminData } from './reducers/adminSlice';
import axios from "./utils/axios";
import { getLangFromCache } from "./utils/helpers";
import { generateAuthenticationTokens } from "./api/afterLogin/setting";
import { encryptData } from "./helpers/crypto_helper";
import { createSPAuthLocalStorage } from "./helpers/spauth_token_helper";
import { readCookie, removeCookie } from "./utils/cookie";

function App() {

  useLangInit(commonModuleName);
  const [apiLoaded, setApiLoaded] = useState(false);
  const isLoggedIn = useSelector((state) => state.user.user.is_logged_in);
  const adminData = useSelector((state) => state.admin);
  const configData = useSelector((state) => state.config)
  const dispatch = useDispatch();

  dispatch(setAdminData({language:getLangFromCache() ? getLangFromCache() :"en"}));
 
  let s3_url = useSelector((state) => {
    return (typeof state.admin.header !== "undefined" && typeof state.admin.header == "object") ? state.admin.header.s3_url : "";
  });

  if ((typeof s3_url == 'undefined' || !s3_url) && (typeof adminData.header !== "undefined" && typeof adminData.header == "object")) {
    s3_url = adminData.header.s3_url ?? '';
  }

  const initUserData = async () => {
    try {
      let initDataLocal = await getInitData();
      initDataLocal = initDataLocal.data;
      const { user, miscellaneous } = initDataLocal;
      localStorage.setItem("data_version", initDataLocal.miscellaneous.data_version);
      dispatch(setUserData({ user, miscellaneous }));
      
      let loginCheckUrl = window.location.origin;
      let loginCheck = await axios.request({
        url:`${loginCheckUrl}/login/login_check`,
        method: "get",
      });
      if(loginCheck && loginCheck.data.data) {
        const {access_token, message_base_url, s3_url, certificate_upload_path, has_certificate_document, idp, news_feed_base_url, profile_completed, public_profile, discussion_form_enable, dms_setting, dms_api_url, mail_email, global_tax_percentage, address_mandatory, phno_mandatory, org_mandatory} = loginCheck.data.data;
        const { us_uuid, id  } = loginCheck?.data?.session?.user ?? {};

        /* GENERATE AUTHENTICATION TOKENS */
        if (loginCheck?.data?.data?.access_token) {
          const enableKey          = `SPAUTH_${id}`;
          const isSPStorageEnabled = localStorage.getItem(enableKey);

          const response     = await generateAuthenticationTokens(loginCheck?.data?.data?.access_token, isSPStorageEnabled ? true : false);
          const authTokens   = response.auth_tokens;  
          /* ALLOWED PRODUCTS */
          if (response?.allowed_products) {
            const { features, user_id, lang_src_url, tenant_domain, products, account_id, account_domain, is_custom_language, us_role_id, us_timezone, us_uid, us_bms_role_id, us_dms_role_id, header, us_name, us_email_verified, user_sp_enabled } = response.allowed_products;
            const secret = encryptData(response.allowed_products.secret);
            dispatch(setAdminData({ features, lang_src_url, tenant_domain, products, account_id, is_custom_language, account_domain, us_timezone, us_role_id, us_uid, us_bms_role_id, us_dms_role_id, header, us_name, secret, us_email_verified,user_id, user_sp_enabled}));
          }
          /* ALLOWED PRODUCTS */
          if (isSPStorageEnabled == undefined || isSPStorageEnabled == null) {
            const authenticationTokens = authTokens;
            const expiryTimestamp      = Date.now() + 30 * 60 * 1000; // 30 minutes in ms
            localStorage.setItem(`SPAUTH_${id}`, expiryTimestamp);
            createSPAuthLocalStorage(id, authenticationTokens);
          }
        }
        
        dispatch(setConfigData({ access_token, messageBaseUrl: message_base_url, s3_url, certificate_upload_path, has_certificate_document, idp, newsFeedBaseUrl: news_feed_base_url, profile_completed, public_profile, user_uuid: us_uuid, id:id, session:loginCheck.data.session.user, discussionFormEnable: discussion_form_enable, dms_setting, dms_api_url, mail_email, global_tax_percentage, address_mandatory, phno_mandatory, org_mandatory}));
      } else {
        let { s3_url } = loginCheck.data;
        dispatch(setConfigData({ s3_url }));
      }

      let secondaryDataLocal = await getCache("secondary_data", getSecondaryData, {}, 2592000);
      secondaryDataLocal = secondaryDataLocal.data;
      const { website, favicon, footer_pages, fields, headerMenus, paths } = secondaryDataLocal;
      dispatch(setUserData({ website, favicon, footer_pages, fields, headerMenus, paths }));
      setTitle(website.site_name);
      setApiLoaded(initDataLocal.miscellaneous.data_version);
    } catch (error) {
      console.error("Init Error", error);
    }
  };

  useEffect(() => {
    if (!apiLoaded) {
      /* CHECK IF EMAIL / CONTACT NUMBER UPDATED */
      if (localStorage.getItem('email_contact_updated')) {
        const preview_as_user = readCookie("preview_as_user");
        const origin          = window.location.origin;
        localStorage.clear();
        document.cookie.split(";").forEach(cookie => {
          const name = cookie.split("=")[0].trim();
          removeCookie(name);
        })
        if (preview_as_user === "preview_as_user") {
          window.location.assign(`${origin}/logout/admin_as_user/`);
        } else {
          window.location.replace(`${origin}/logout`);
        }
        return;
      }
      initUserData();
    }
    let cart = localStorage.getItem('mycart_count')
    dispatch(setCart({ cartCount: cart }));
  }, []);

  if (!apiLoaded) {
    return (
      <SomethingWentWrong />
    );
  }
  return StudentRoute;
}

export default App;
